import type { JSX } from 'react';
import { useEffect, useState } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { NoticesApi } from '@apply/api';
import { PostClosingCertificationModal } from '../modals/PostClosingCertificationModal';
import { Tooltip } from 'devextreme-react/tooltip';

interface IPostClosingButtonParameters {
    loanId: number | undefined;
    loanPropertyId: number | undefined;
    applicationInsights: ApplicationInsights;
}
export const PostClosingButton = ({ loanId, loanPropertyId, applicationInsights }: IPostClosingButtonParameters): JSX.Element => {
    const noticesApi = new NoticesApi.NoticesApi(applicationInsights);
    const [isPostClosingModalOpen, set_isPostClosingModalOpen] = useState<boolean>(false);
    const [canSendPostClosing, set_canSendPostClosing] = useState<boolean>(false);
    const [checkCompleted, set_checkCompleted] = useState<boolean>(false);

    //Api call to check to see if the button can be enabled or not
    useEffect(() => {
        if (!loanPropertyId) return;

        noticesApi
            .getPostClosingCertSendingAvailability(loanPropertyId)
            .then((result: boolean) => {
                set_canSendPostClosing(result);
                set_checkCompleted(true);
            })
            .catch(() => {
                // If the API fails, safest fallback is "false"
                set_canSendPostClosing(false);
                set_checkCompleted(true);
            });
    }, [loanPropertyId]);

    const handleClose = () => {
        set_isPostClosingModalOpen(false);
    };

    return (
        <>
            <button
                id='postClosingButton'
                className='button primary'
                disabled={!canSendPostClosing}
                onClick={() => set_isPostClosingModalOpen(true)}
            >
                Post Closing
            </button>
            {checkCompleted && !canSendPostClosing && (
                <Tooltip
                    target='#postClosingButton'
                    showEvent='mouseenter'
                    hideEvent='mouseleave'
                >
                    Go to Notices to Resend this Cert.
                </Tooltip>
            )}

            <PostClosingCertificationModal
                loanId={loanId}
                loanPropertyId={loanPropertyId}
                isOpen={isPostClosingModalOpen}
                applicationInsights={applicationInsights}
                onClose={handleClose}
            />
        </>
    );
};
